import { focusInput } from "../../shared/utils";
import AbstractShapeMode from "./AbstractShapeMode";
import Coordinate from "../support/Coordinate";
import Rectangle from "../shapes/Rectangle";

export default class RectangleMode extends AbstractShapeMode {
    firstCoordinate = null;
    secondCoordinate = null;
    xDir = null;
    yDir = null;

    display() {
        if (this.firstCoordinate) {
            this.drawMenu.appearance.apply();
            this.p.rectMode(this.p.CORNERS);
            this.p.rect(this.firstCoordinate.currentX, this.firstCoordinate.currentY, this.secondCoordinate.currentX, this.secondCoordinate.currentY);
        }
    }

    activate() {
        this.input.setDrawMode('rectangle');
    }

    pressMouseOnCanvas() {
        if (!this.firstCoordinate) {
            this.firstCoordinate = this.view.snappedCoordinate;
            this.secondCoordinate = this.view.snappedCoordinate;
        } else {
            this.makeShape();
        }
    }

    makeShape() {
        if (!this.firstCoordinate) {
            return;
        }
        if (this.firstCoordinate.currentX == this.secondCoordinate.currentX
            || this.firstCoordinate.currentY == this.secondCoordinate.currentY
        ) {
            return;
        }
        let rectangle = Rectangle.createFromCorners(
            this.provider,
            this.firstCoordinate,
            this.secondCoordinate,
            this.drawMenu.appearance.clone(),
            this.speciesIds,
            this.label,
        );
        this.elements.add(rectangle);
        this.reset();
    }

    mouseMoved() {
        if (this.firstCoordinate) {
            let [dx, dy] = this.secondCoordinate.diff(this.firstCoordinate);
            this.secondCoordinate = new Coordinate(
                this.provider,
                this.sticky['width']
                    ? this.firstCoordinate.absX + (dx > 0 ? this.sticky['width'].value() : -this.sticky['width'].value())
                    : this.view.snappedAbsX,
                this.sticky['height']
                    ? this.firstCoordinate.absY + (dy > 0 ? this.sticky['height'].value() : -this.sticky['height'].value())
                    : this.view.snappedAbsY
            );
            let [dx2, dy2] = this.firstCoordinate.diff(this.secondCoordinate);
            if (!this.sticky['width']) {
                this.input.width.value(this.p.round(this.p.abs(dx2) / 100, 2));
            }
            if (!this.sticky['height']) {
                this.input.height.value(this.p.round(this.p.abs(dy2) / 100, 2));
            }
        }
    }

    reset() {
        super.reset();
        this.firstCoordinate = null;
        this.secondCoordinate = null;
    }

    getTips() {
        if (!this.firstCoordinate) {
            return 'Click to place the first corner of the rectangle.';
        }
        return 'Click to place the second corner of the rectangle. Press G to change the height, W to change the width.';
    }

    pressKey(code) {
        switch (code) {
            case 71: // G
                focusInput(this.getInput('height'));
                return;
            case 87: // W
                focusInput(this.getInput('width'));
                return;
        }
    }
}
